
export const common = {
  'call.us': 'Soita meille',
  'privacy.policy': 'Tietosuojakäytäntö',
  'select.location': 'Valitse sijaintisi',
  'location.description': 'Valitse sijaintisi soittaaksesi oikeaan numeroon',
  'usa': 'Yhdysvallat',
  'non.usa': 'Muut maat Puhelu tai WhatsApp',
  'documents.downloads': 'Dokumentit ja lataukset',
  'item': 'Tuote',
  'value': 'Arvo',
  'price': 'Hinta',
  'product': 'Tuote',
  'msrp': 'Suositushinta',
};
